<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }" :custom-messages="{
          required: 'El email es obligatorio',
          email: 'Debe ser un email válido',
        }">
          <base-input type="email" label="Email" placeholder="Email" v-model="user.email" autocomplete="username">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-6">
        <ValidationProvider name="password" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'La contraseña es obligatoria',
        }">
          <base-input type="password" label="Contraseña" placeholder="Contraseña" v-model="user.password"
            autocomplete="current-password">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <button type="submit" class="btn orange-btn float-right">Continuar</button>
  </div>
</template>

<script>
export default {
  name: "LoginForm",

  props: {
    user: { type: Object },
  },

  data() {
    return {
      form: {
        email: null,
        password: null,
      },
    };
  },
};
</script>
